import NpsSolucx from '@eduzz/nps-react-solucx';
import type { FC } from 'react';
import React, { memo } from 'react';
import { useObservable } from 'react-use-observable';
import { NPS_ACCESS_KEY, NPS_JOURNEY } from 'settings';
import { npsService } from 'v2/services/nps';

const SolucxNps: FC = () => {
  const [data] = useObservable(() => npsService.getInfo('nps'), []);

  if (!data?.showWidget) return null;

  return (
    <NpsSolucx
      app='eduzz'
      accessKey={NPS_ACCESS_KEY}
      transactionId={data.transactionId}
      journey={NPS_JOURNEY}
      eduzzId={data.clientId}
      email={data.email}
      name={data.name}
      belt={data.belt}
    />
  );
};

export default memo(SolucxNps);
